// src/components/ShopProtectedRoute.tsx
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useFrontendAuth } from '../hooks/useAuth';
import { ProtectedRouteProps } from '../types';

/**
 * Guards shop routes that require a logged-in user.
 * While auth is resolving, render nothing (avoid mobile flash of spinner → login).
 * Guests are sent straight to /login with return path.
 */
const ShopProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const { user, loading, isAuthReady } = useFrontendAuth();
    const location = useLocation();

    if (loading || !isAuthReady) {
        // Neutral placeholder — no full-page spinner that flashes before login redirect
        return <div className="min-h-[40dvh]" aria-busy="true" />;
    }

    if (!user) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }

    // Note: There is intentionally no admin-only functionality on the shop frontend.
    // All admin work is done via the separate /admin panel.

    return children ? <>{children}</> : <Outlet />;
};

export default ShopProtectedRoute;